import { render, staticRenderFns } from "./businessplan.vue?vue&type=template&id=6f90d94c&scoped=true&"
import script from "./businessplan.vue?vue&type=script&lang=js&"
export * from "./businessplan.vue?vue&type=script&lang=js&"
import style0 from "./businessplan.vue?vue&type=style&index=0&id=6f90d94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90d94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
